// src/components/School/SchoolFooter.jsx

import React from "react";

const SchoolFooter = ({ school }) => (
  <footer className="bg-indigo-900 text-white py-6 mt-10">
    <div className="max-w-6xl mx-auto px-4 flex flex-col md:flex-row justify-between">
      <div>
        <h4 className="font-bold text-lg">{school.name}</h4>
        <p className="text-sm">{school.fullAddress}, {school.city}</p>
      </div>
      <div className="text-sm mt-4 md:mt-0">
        &copy; {new Date().getFullYear()} All rights reserved. Powered by Isnartech ERP.
      </div>
    </div>
  </footer>
);

export default SchoolFooter;
